module.exports = __webpack_public_path__ + "static/media/simplonoi-headline-webfont.a1aaf1ba.eot";